module.exports = __webpack_public_path__ + "img/u1231.585a8bb1.png";